export default "/images/arrow-down-right.svg?aa3c7a82948db3b4e0f691af5b52ac14";